var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconMailColor = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 67.901,
  height: 58.945
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#e6ae45",
  d: "M33.95 0L0 15.678l33.95 28.918 33.951-28.918z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M5.711 13.542h55.712v26.485H5.711z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#f7cf80",
  d: "M33.95 35.326L0 15.678v43.267h67.901V15.678z"
})));
export default SvgIconMailColor;